import React from "react"
import FieldProjectTemplate from "../../template";
import ProjectTypeIcon from "../../../../../../gd-components/icons/project/project-type-icon/project-type-icon";

// const debug = "FieldProjectTemplate_FormValueNotEmpty"
const debug = false

type Props = {
    className?      : string,
    children        : any
    option          : Option
    configOptions   : any
    field           : FieldProjectTemplate
    disabled        : boolean
    onClick         : callback
}

export default function FieldProjectTemplate_FormValueNotEmpty(props:Props) {

    let label : any     = props.option.label

    const size      = _.get(props.configOptions, 'size', '36')
    const hideLabel = _.get(props.configOptions, 'hideLabel', false)

    const valueClasses = Classes("ui5-field-form-editable dropdown-form not-selectable", 'h-{0}'.f(size), props.className)

    const labelClasses = Classes('dropdown-label txt-truncate', {
        'ui5-txt-default'           : !props.disabled,
        'ui5-txt-no-accent-default' : props.disabled,
    })

    return (
        <>
            <div className={valueClasses} onClick={props.onClick}>
                <ProjectTypeIcon className="m-r-8" projectId={props.option.value}/>
                {!hideLabel && <div className={labelClasses}>{label}</div>}
            </div>
            {props.children}
        </>
    )
}
